import { EmployeeLicenseUpgradeComponent } from '../../businesses/components/employee-license-upgrade.component';
import { AppErrorCode } from 'src/app/_models/app-error-code.enum';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, ViewChild, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  FormBuilder
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api';
import * as _ from 'lodash';
import {
  Rights,
  FeatureKey,
  Status,
  Roles,
  Application
} from './../../../_models/feature';
import { ELList } from './../../kunde-EL/models/el-list.model';
import { KundeELUser } from './../../kunde-EL/models/el-edit';
import { EmployeeServices } from './../../employees/services/employee.services';
import { UserService } from './../../users/services/user.service';
import { ValidationService } from './../../shared/services/validation.service';
import { HelperService } from './../../../_services/helper.service';
import { Module } from './../../follow-ups/models/deviation';
import { EmployeeRights } from './../../employees/models/employee';
import { SaveUsers, UserCredential } from './../../users/models/user';

import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { BusinessServices } from '../services/business.services';
import { ProjectServices } from '../../projects/services/project.service';
import { BaseServices } from '../../kuba.services';
import { ProjectList } from '../../projects/models/projectlist';
import { FireDeviationUserDto, ProjectUserDto } from '../models/businessView';
import { applyDeviationRightsExclusivity } from '../../shared/helpers/deviation-rights.helper';
import { LanguageId } from 'src/app/_models/language-id.enum';

@Component({
  selector: 'edit-users',
  templateUrl: 'business-user-edit.component.html',
  standalone: false
})
export class BusinessUsersEditComponent implements OnInit {
  @ViewChild(EmployeeLicenseUpgradeComponent) licenseUpgrade: EmployeeLicenseUpgradeComponent;
  get licenseBusinessId(): number { return this.businessId; }
  private handleUserLimitError(error: { error?: { Code?: number } }): void {
    this.loading = false; this.loader = false;
    if (error.error?.Code === AppErrorCode.EmployeeLimitReached) this.licenseUpgrade.open();
    else this.notifications.error('UI_NOTIFICATIONS.TRY_AGAIN');
  }

  //#region variables
  private readonly notifications = inject(NotificationService);
  businessUserForm: FormGroup;
  updatePasswordForm: FormGroup;
  mobileCodes: SelectItem[];
  Status: any;
  Roles: SelectItem[];
  Language: SelectItem[];
  showPassword: any;
  Id: number;
  loading = false;
  loader = false;
  rightsData: any = [];
  userRightsData: any = [];
  guestRightsData: any = [];
  editorRightsData: any = [];
  businessId: number;
  editedUser = false;
  editedGuest = false;
  editedEditor = false;
  hidden = false;
  roleFilter = [3, 4, 5]; // editor, guest and user
  guest = [4];
  isNewUser = false;
  cachedUserName: string;
  usernameWarning: string | null = null;
  userCredentials = new UserCredential();
  showPasswordResetDialog = false;
  validationErrors: string[] = [];
  showProjectDialog = false;
  showKundeELDialog = false;
  isRightSelect: boolean;
  hideEmployeeRights = false;
  featureId: number;
  featureKey: number;
  languageId: number;
  showChooseProject = false;
  showChooseKundeEL = false;
  projectList: any;
  FDVList: any;
  selectedProject: any;
  selectedFDV: any;
  selectedContract: any;
  selectedManager: any = [];
  selectedObserver: any = [];
  isLoginUser: boolean;
  contractList: any;
  isUser = false;
  pageTitle: string;
  isShowManagerUserDepartment = false;
  departments: SelectItem[];
  ManagerSelected: any;
  IsTOCApproved: any;
  isElectroRights = false;
  isFDVExists: boolean = false;
  isProjExists: boolean = false;
  isKundeElExiats: boolean = false;
  routeSub: any;
  createdBy: number;
  createdOn: string;
  showElectroClientRights = false;
  electroRightsHead: string;
  showLoader = false;
  hideEmployeList = false;
  isArchive: boolean;
  applicationId: number;
  inValidUserName = false;
  private subscriptions: Subscription[] = [];
  dialogDisplay = false;
  isMobile: boolean;
  isPasswordValid = false;

  //#endregion
  //#region constructor

  /**
   * constructor
   * @param route {ActivatedRoute}
   * @param router {Router}
   * @param userService {UserService}
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    public employeeServices: EmployeeServices,
    public businessServices: BusinessServices,
    public projectServie: ProjectServices,
    public formBuilder: FormBuilder,
    private _location: Location,
    private translate: TranslateService
  ) {
    this.Id = +this.route.snapshot.params['uid'];
    let businessUserData = this.route.snapshot.data['userData'];
    this.applicationId = BaseServices.ApplicationId;
    this.featureId = businessUserData ? businessUserData.FeatureId : 0;
    this.isNewUser = this.Id === 0;
    this.onRightsDisableOwnUser();
    if (this.Id === BaseServices.UserId) {
      this.isUser = true;
      this.businessId = BaseServices.BusinessId;
    } else if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
      this.businessId = this.route.snapshot.parent?.params['bid'];
    } else {
      this.businessId = BaseServices.BusinessId;
    }
    this.initForm();
    this.subscriptions.push(
      (this.routeSub = this.router.events.subscribe(val => {
        if (this.router.url.indexOf('user/edit') > -1) {
          if (this.Id != +this.route.snapshot.params['uid']) {
            this.Id = +this.route.snapshot.params['uid'];
            this.ngOnInit();
          }
        }
      }))
    );
  }
  //#endregion
  //#region page-events
  ngOnInit() {
    if (BaseServices.roleId == '5') {
      let leftNav = JSON.parse(sessionStorage.getItem('leftNav')!);
      let filteredTemplate = HelperService.filterTree(
        'Archive',
        leftNav.filter((x: any) => {
          if (x.name === 'Archive' && x.checked == true) {
            this.isArchive = true;
          }
        }),
        'isArchive'
      );
    }

    document.querySelector('body').classList.remove('opened');
    this.pageTitle = this.route.snapshot.queryParams['Title'];
    this.updatePasswordForm = this.formBuilder.group({
      passwordValidation: this.formBuilder.group(
        {
          Password: ['', [Validators.required]],
          ConfirmPassword: ['', [Validators.required]]
        }
      )
    });
    let businessUserData = this.route.snapshot.data['userData'];
    let businessDepartment = this.route.snapshot.data['department'];
    if (businessUserData.Mobile == '') {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    this.cachedUserName = businessUserData.Username;
    this.featureId = businessUserData.FeatureId;
    this.featureKey = businessUserData.FeatureKey;
    this.languageId = parseInt(sessionStorage.getItem('languageId')!);
    if (businessUserData) {
      this.initForm(businessUserData);
    }
    this.Language = [];
    this.Language.push({ label: 'Select a Language', value: null });
    this.subscriptions.push(
      this.userService.getLanguages().subscribe((result: any) => {
        let cLanguage = result;
        if (cLanguage) {
          cLanguage.forEach((lang: any) => {
            this.Language.push({ label: lang.Title, value: lang.Id });
          });
        }
      })
    );

    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Roles = [];
        this.Roles.push({ label: val.SELECT, value: '' });
      })
    );

    let businessUserRole = this.route.snapshot.data['userrole'];
    let RoleId = +this.businessUserForm.get('RoleId')!.value;
    if (RoleId === 0) {
      this.isRightSelect = false;
    } else {
      this.isRightSelect = true;
    }
    this.roleFilter.push(RoleId);
    let roleFiltered = [];
    if (
      businessUserData.FeatureId === Module.CONTRACTOR ||
      businessUserData.FeatureId === Module.CLIENT ||
      businessUserData.FeatureId === Module.CLIENT_CONTACT ||
      businessUserData.FeatureId === Module.CONTRACTOR_CONTACT
    ) {
      roleFiltered = businessUserRole.filter(
        (x: any) => this.guest.indexOf(x.Id) > -1
      );
    } else if (
      businessUserData.FeatureId === Module.EMPLOYEES ||
      businessUserData.FeatureId === Module.CONTACT
    ) {
      roleFiltered = businessUserRole.filter(
        (x: any) => this.roleFilter.indexOf(x.Id) > -1
      );
    } else {
      roleFiltered = businessUserRole.filter(
        (x: any) => this.roleFilter.indexOf(x.Id) > -1
      );
    }
    if (roleFiltered.length == 1) {
      this.subscriptions.push(
        this.translate.stream('SELECT_ROLE_DROP').subscribe(val => {
          this.Roles = [];
          this.Roles.push(
            { label: val.SELECT, value: null },
            { label: val.GUEST, value: 4 }
          );
        })
      );
    } else if (roleFiltered.length == 3) {
      this.subscriptions.push(
        this.translate.stream('SELECT_ROLE_DROP').subscribe(val => {
          this.Roles = [];
          this.Roles.push(
            { label: val.SELECT, value: null },
            { label: val.EDITOR, value: 3 },
            { label: val.GUEST, value: 4 },
            { label: val.USER, value: 5 }
          );
        })
      );
    }

    this.mobileCodes = [];
    let mobileCode = this.route.snapshot.data['countryCode'];
    if (mobileCode) {
      mobileCode.forEach((phoneType: any) => {
        this.mobileCodes.push({
          label: '+' + phoneType.Phonecode,
          value: phoneType.Id
        });
      });
    }
    this.subscriptions.push(
      this.translate.stream('SELECT_STATUS_DROP').subscribe(val => {
        this.Status = [];
        this.Status.push(
          { label: val.SELECT, value: '' },
          { label: val.INACTIVE, value: '2' },
          { label: val.ACTIVE, value: '1' }
        );
      })
    );
    this.projectList = <ProjectList[]>this.route.snapshot.data['projectList'];
    if (ProjectList != null) {
      this.subscriptions.push(
        this.projectServie
          .getProjectByGuest(+this.route.snapshot.params['uid'])
          .subscribe((res: any) => {
            if (res !== null) {
              this.selectedProject = [];
              res.forEach((id: any) => {
                this.selectedProject.push({ Id: id });
              });
            }
          })
      );
    }

    this.contractList = <ELList[]>this.route.snapshot.data['list'];
    this.subscriptions.push(
      this.userService.getUsersById(this.Id).subscribe((res: any) => {
        this.IsTOCApproved = res.IsTOCApproved;
      })
    );
    const userControl = <FormArray>(
      this.businessUserForm.controls['userCategories']
    );
    console.log('businessUserData2', this.businessUserForm);
    if (this.editedUser) {
      let isViewDeviationChecked = false;
      userControl['controls'].forEach(rightControl => {
        if (+Object.keys(rightControl.value)[0] === Rights.VIEW_DEVIATION) {
          let key = Object.keys(rightControl.value)[0];
          let value = Object.keys(rightControl.value).map(key => {
            if (key) {
              let test = rightControl.value[key];
              isViewDeviationChecked = rightControl.value[key];
            }
          });
        }
        if (
          isViewDeviationChecked &&
          +Object.keys(rightControl.value)[0] ===
            Rights.DISPLAY_OWN_DEVIATION_ONLY
        ) {
          rightControl.disable();
        }
        if (+Object.keys(rightControl.value)[0] === Rights.HIDE_EMPLOYEE_LIST) {
          let key = Object.keys(rightControl.value)[0];
          let value = Object.keys(rightControl.value).map(key => {
            if (key) {
              this.hideEmployeList = rightControl.value[key];
            }
          });
        }
      });
      userControl['controls'].forEach(rightControl => {
        if (this.hideEmployeList) {
          if (+Object.keys(rightControl.value)[0] === Rights.APPROVE_ABSENSE) {
            rightControl.disable();
          }
          if (+Object.keys(rightControl.value)[0] === Rights.APPROVE_LEAVE) {
            rightControl.disable();
          }
          if (
            +Object.keys(rightControl.value)[0] === Rights.APPROVE_TIMETABLE
          ) {
            rightControl.disable();
          }
          if (+Object.keys(rightControl.value)[0] === Rights.ADD_NEW_EMPLOYEE) {
            rightControl.disable();
          }
          if (
            +Object.keys(rightControl.value)[0] ===
            Rights.EDIT_DEPARTMENT_EMPLOYEE_RIGHTS
          ) {
            rightControl.disable();
          }
        }
      });
    }
    if (this.isLoginUser) {
      this.businessUserForm.get('RoleId')!.disable();
    } else {
      this.businessUserForm.get('RoleId')!.enable();
    }
  }

  //#endregion

  get userFormGroups() {
    return this.businessUserForm.get('userCategories') as FormArray;
  }

  get guestFormGroups() {
    return this.businessUserForm.get('guestCategories') as FormArray;
  }

  get editFormGroups() {
    return this.businessUserForm.get('editorCategories') as FormArray;
  }

  //#region control-events
  /**
   * Role dropdown change event
   * @param e {event}
   */
  onRoleDropDownChanged(e: any) {
    if (e.value === '') {
      this.isRightSelect = false;
    } else {
      this.isRightSelect = true;
      this.isShowManagerUserDepartment = false;
      this.setRoleVisiblity(e.value);
    }
  }

  onPasswordChange(pwd: string, resetDialog: boolean = false) {
    if (resetDialog) {
      this.updatePasswordForm.patchValue({
        passwordValidation: {
          Password: pwd,
          ConfirmPassword: pwd
        }
      });
    } else {
      this.businessUserForm.patchValue({
        newPasswordValidation: {
          Password: pwd,
          ConfirmPassword: pwd
        }
      });
    }
  }

  /**
   * With any changes in validation by child component
   * @param valid boolen
   */
  onValidChange(valid: boolean, resetDialog: boolean = false) {
    if (resetDialog) {

      const pwGroup = this.updatePasswordForm.get('passwordValidation') as FormGroup;

      this.isPasswordValid = valid;

      if (valid) {
        pwGroup.setErrors(null);
      } else {
        pwGroup.setErrors({ invalidPassword: true });
      }
    } else {

      const pwGroup = this.businessUserForm.get('newPasswordValidation') as FormGroup;

      this.isPasswordValid = valid;

      if (valid) {
        pwGroup.setErrors(null);
      } else {
        pwGroup.setErrors({ invalidPassword: true });
      }
    }
  }
  /**
   * Enable/Disable the rights on checkbox
   * @param e {event}
   * @param rightsId {number}
   */
  onRightsCheckboxChange(e: any, rightsId: number, rightCategory: string) {
    if (+rightsId === Rights.ACTIVE_ACCOUNT) {
      if (rightCategory === 'USER') {
        this.userRightsCheckBoxEventControl(e, rightsId, 'userCategories');
      } else if (rightCategory === 'GUEST') {
        this.userRightsCheckBoxEventControl(e, rightsId, 'guestCategories');
      } else if (rightCategory === 'EDITOR') {
        this.userRightsCheckBoxEventControl(e, rightsId, 'editorCategories');
      }
    }
    if (rightCategory === 'USER') {
      const userControl = <FormArray>(
        this.businessUserForm.controls['userCategories']
      );
      if (+rightsId === Rights.ADMINISTRATE_DEVIATION) {
        userControl['controls'].forEach(rightControl => {
          rightControl.enable();
        });
      } else if (
        +rightsId === Rights.ADD_NEW_EMPLOYEE ||
        +rightsId === Rights.EDIT_DEPARTMENT_EMPLOYEE_RIGHTS
      ) {
        userControl['controls'].forEach(rightControl => {
          if (
            +Object.keys(rightControl.value)[0] ===
            Rights.EDIT_DEPARTMENT_EMPLOYEE_RIGHTS
          ) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: true
              });
              if (+rightsId === Rights.ADD_NEW_EMPLOYEE) {
                rightControl.disable();
              }
              userControl['controls'].forEach(editPage => {
                if (+Object.keys(editPage.value)[0] == Rights.EDIT_MY_PAGE) {
                  editPage.patchValue({
                    [Object.keys(editPage.value)[0]]: true
                  });
                  return;
                }
              });
            } else {
              rightControl.enable();
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
            }
          }
        });
      } else if (+rightsId === Rights.HIDE_EMPLOYEE_LIST) {
        userControl['controls'].forEach(rightControl => {
          if (
            +Object.keys(rightControl.value)[0] ===
              Rights.EDIT_DEPARTMENT_EMPLOYEE_RIGHTS ||
            +Object.keys(rightControl.value)[0] === Rights.ADD_NEW_EMPLOYEE ||
            +Object.keys(rightControl.value)[0] === Rights.APPROVE_ABSENSE ||
            +Object.keys(rightControl.value)[0] === Rights.APPROVE_LEAVE ||
            +Object.keys(rightControl.value)[0] === Rights.APPROVE_TIMETABLE
          ) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              rightControl.disable();
            } else {
              rightControl.enable();
            }
          }
        });
      } else if (+rightsId === Rights.RESPONSIBLE_FOR_FOLLOWUP) {
        userControl['controls'].forEach((rightControl: any = FormControl) => {
          if (
            +Object.keys(rightControl.value)[0] ===
            Rights.RESPONSIBLE_FOR_FOLLOWUP
          ) {
            if (e.target.checked) {
              this.isShowManagerUserDepartment = true;
            } else {
              this.isShowManagerUserDepartment = false;
              this.businessUserForm.get('selectedManager')!.reset();
              this.selectedManager = [];
            }
          }
        });
      }
    }
    if (rightCategory === 'USER' || rightCategory === 'GUEST') {
      let userGuestControl: any;
      if (rightCategory === 'USER') {
        userGuestControl = <FormArray>(
          this.businessUserForm.controls['userCategories']
        );
      } else {
        userGuestControl = <FormArray>(
          this.businessUserForm.controls['guestCategories']
        );
      }
      if (+rightsId === Rights.VIEW_DEVIATION) {
        userGuestControl['controls'].forEach((rightControl: FormControl) => {
          if (
            +Object.keys(rightControl.value)[0] ===
              Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT ||
            +Object.keys(rightControl.value)[0] ===
              Rights.ADMINISTRATE_DEVIATION ||
            +Object.keys(rightControl.value)[0] === Rights.DEVIATION_RIGHTS
          ) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              rightControl.disable();
            } else {
              rightControl.enable();
            }
          }
        });
      }
      if (+rightsId === Rights.DEVIATION_RIGHTS) {
        userGuestControl['controls'].forEach((rightControl: any) => {
          if (
            +Object.keys(rightControl.value)[0] === Rights.VIEW_DEVIATION ||
            +Object.keys(rightControl.value)[0] ===
              Rights.DISPLAY_OWN_DEVIATION_ONLY ||
            +Object.keys(rightControl.value)[0] ===
              Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT
          ) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              rightControl.disable();
            } else {
              rightControl.enable();
            }
          }
        });
      }
      if (+rightsId === Rights.ADMINISTRATE_DEVIATION) {
        userGuestControl['controls'].forEach((rightControl: any) => {
          if (
            +Object.keys(rightControl.value)[0] === Rights.VIEW_DEVIATION ||
            +Object.keys(rightControl.value)[0] ===
              Rights.DISPLAY_OWN_DEVIATION_ONLY ||
            +Object.keys(rightControl.value)[0] ===
              Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT
          ) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              rightControl.disable();
            } else {
              rightControl.enable();
            }
          }
        });
      }
      if (+rightsId === Rights.VIEW_DEVIATION) {
        userGuestControl['controls'].forEach((rightControl: any) => {
          if (
            +Object.keys(rightControl.value)[0] ===
            Rights.DISPLAY_OWN_DEVIATION_ONLY
          ) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              rightControl.disable();
            } else {
              rightControl.enable();
            }
          }
        });
      }
      if (+rightsId === Rights.DISPLAY_OWN_DEVIATION_ONLY) {
        userGuestControl['controls'].forEach((rightControl: any) => {
          if (
            +Object.keys(rightControl.value)[0] ===
            Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT
          ) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              rightControl.disable();
            } else {
              rightControl.enable();
            }
          }
          if (+Object.keys(rightControl.value)[0] === Rights.VIEW_DEVIATION) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              rightControl.disable();
            } else {
              rightControl.enable();
            }
          }
        });
      } else if (+rightsId === Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT) {
        userGuestControl['controls'].forEach((rightControl: any) => {
          if (
            +Object.keys(rightControl.value)[0] ===
              Rights.DISPLAY_OWN_DEVIATION_ONLY ||
            +Object.keys(rightControl.value)[0] === Rights.VIEW_DEVIATION ||
            +Object.keys(rightControl.value)[0] ===
              Rights.ADMINISTRATE_DEVIATION
          ) {
            if (e.target.checked) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              rightControl.disable();
            } else {
              rightControl.enable();
            }
          }
        });
      }
      if (+rightsId === Rights.CHOOSE_PROJECTFDV) {
        userGuestControl['controls'].forEach((rightControl: any) => {
          if (
            +Object.keys(rightControl.value)[0] === Rights.CHOOSE_PROJECTFDV
          ) {
            this.showChooseProject = e.target.checked;
          }
        });
      }
      if (+rightsId === Rights.CHOOSE_KUNDE_EL) {
        userGuestControl['controls'].forEach((rightControl: any) => {
          if (+Object.keys(rightControl.value)[0] === Rights.CHOOSE_KUNDE_EL) {
            this.showChooseKundeEL = e.target.checked;
          }
        });
      } else if (
        e.target.checked &&
        (+rightsId === Rights.HIDE_DEVIATIONS ||
          +rightsId === Rights.DEVIATIONS_READONLY ||
          +rightsId === Rights.EDIT_DEVIATIONS ||
          +rightsId === Rights.ADD_DEVIATIONS)
      ) {
        let electroDevRights = [
          Rights.HIDE_DEVIATIONS,
          Rights.DEVIATIONS_READONLY,
          Rights.EDIT_DEVIATIONS,
          Rights.ADD_DEVIATIONS
        ];
        userGuestControl['controls'].forEach((rightControl: any) => {
          if (
            electroDevRights.indexOf(+Object.keys(rightControl.value)[0]) > -1
          ) {
            if (+Object.keys(rightControl.value)[0] !== +rightsId) {
              rightControl.patchValue({
                [Object.keys(rightControl.value)[0]]: false
              });
              if (this.rightsData) {
                _.each(this.rightsData, (x: EmployeeRights) => {
                  if (+x.id === +Object.keys(rightControl.value)[0]) {
                    x.isChecked = false;
                  }
                });
              }
            }
          }
        });
      }
    }
    if (rightCategory === 'USER' || rightCategory === 'GUEST') {
      applyDeviationRightsExclusivity(
        this.businessUserForm,
        rightCategory === 'USER' ? 'userCategories' : 'guestCategories',
        true
      );
    }
    if (rightCategory === 'EDITOR') {
      const userEditorControl = <FormArray>(
        this.businessUserForm.controls['editorCategories']
      );
      if (+rightsId === Rights.RESPONSIBLE_FOR_FOLLOWUP) {
        userEditorControl['controls'].forEach(
          (rightControl: any = FormControl) => {
            if (
              +Object.keys(rightControl.value)[0] ===
              Rights.RESPONSIBLE_FOR_FOLLOWUP
            ) {
              if (e.target.checked) {
                this.isShowManagerUserDepartment = true;
              } else {
                this.isShowManagerUserDepartment = false;
                this.businessUserForm.get('selectedManager')!.reset();
                this.selectedManager = [];
              }
            }
          }
        );
      }
    }
    if (this.rightsData) {
      _.each(this.rightsData, (x: EmployeeRights) => {
        if (x.id === rightsId) {
          x.isChecked = e.target.checked;
        }
      });
      if (rightCategory === 'USER') {
        this.rightsData.forEach((x: any) => {
          if (
            (x.id == Rights.ADD_NEW_EMPLOYEE && x.isChecked == true) ||
            (x.id == Rights.EDIT_DEPARTMENT_EMPLOYEE_RIGHTS &&
              x.isChecked == true)
          ) {
            this.rightsData.find((element: any) => {
              if (element.id == Rights.EDIT_MY_PAGE) {
                let ischeck: any = (element.isChecked = true);
                return ischeck;
              }
            });
          }
        });
      }
    }
  }
  /**
   * enable or disable checkbox depends upon user roles
   * @param e {any}
   * @param rightsId {number}
   * @param userRole {string}
   */
  userRightsCheckBoxEventControl(e: any, rightsId: number, userRole: string) {
    let isActiveAccountChecked =
      +rightsId === Rights.ACTIVE_ACCOUNT ? e.target.checked : false;
    const userControl = <FormArray>(
      this.businessUserForm.controls[`${userRole}`]
    );
    userControl['controls'].forEach(rightControl => {
      rightControl.enable();
      if (+Object.keys(rightControl.value)[0] !== Rights.ACTIVE_ACCOUNT) {
        if (!isActiveAccountChecked) {
          rightControl.disable();
        } else {
          rightControl.enable();
        }
      }
    });
  }

  onMobileNumber(e: any, limitNumber: any) {
    HelperService.numberFieldValidation(e, limitNumber);
  }
  MobileEvent(event) {
    var mobileNum = document.getElementById('mobilenum') as HTMLButtonElement;
    if (mobileNum.value.length >= 7) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }

  showDialog() {
    this.dialogDisplay = true;
  }
  /**
   * Generate Random password
   */

  /**
   * Save the User details based on the edited user
   */
  saveUser() {
    if (this.businessUserForm.get('Username')?.hasError('invalidUserNameWithId')) {
      return;
    }
    this.loading = true;
    this.loader = true;
    let user = new SaveUsers();
    user.Name = this.businessUserForm.value.Name;
    user.Email = this.businessUserForm.value.Email;
    user.RoleId = this.businessUserForm.get('RoleId')!.value;
    user.Status = '1';
    user.LanguageId = this.languageId
      ? this.languageId
      : BaseServices.userLanguageId;
    user.Password = this.businessUserForm.value.newPasswordValidation.Password;
    user.Username = this.businessUserForm.value.Username;
    user.ApplicationId = BaseServices.ApplicationId;
    user.BusinessId = this.businessId;
    user.FeatureId = this.featureId;
    user.FeatureKey = this.featureKey;
    user.Mobile = this.businessUserForm.value.Mobile;
    user.CountryCode = this.businessUserForm.value.countryCode.toString();
    user.CreatedBy = this.Id ? this.Id : 0;
    user.IsTOCApproved = this.IsTOCApproved;
    if (window.name === 'Remote') {
      user.LanguageId = LanguageId.Norwegian;
    } else {
      user.LanguageId = BaseServices.userLanguageId;
    }
    if (this.rightsData && this.rightsData.length > 0) {
      user.Status =
        +this.rightsData[0].id === Rights.ACTIVE_ACCOUNT &&
        this.rightsData[0].isChecked === true
          ? Status.Active.toString()
          : Status.Inactive.toString();
      user.Rights = JSON.stringify(this.rightsData);
    } else {
      user.Rights = null!;
    }
    if (this.Id) {
      user.Id = this.Id;
      user.CreatedBy = this.createdBy;
      user.CreatedOn = this.createdOn;
      this.subscriptions.push(
        this.userService.updateUser(user.Id, user, true).subscribe(isUpdate => {
          if (isUpdate) {
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
          }
          this.loading = false;
          this.loader = false;
        }, error => this.handleUserLimitError(error))
      );
    } else {
      this.subscriptions.push(
        this.userService.addusers(user, true).subscribe(isAdded => {
          if (isAdded) {
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.Id = (isAdded as any).Id;
            this.loading = false;
            this.loader = false;
          }
        }, error => this.handleUserLimitError(error))
      );
    }
  }
  //#endregion
  //#region methods
  /**
   * Bind the UserRights
   * @param data {any}
   */

  bindRightsCheckbox(data?: any) {
    // for user role dropdown
    if (this.isArchive == true) {
      this.userRightsData = [
        {
          id: '1',
          name: 'ACTIVE_ACCOUNT',
          isChecked: true,
          rightsType: 1
        },
        {
          id: '2',
          name: 'EDIT_MY_PAGE',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '3',
          name: 'EDIT_MANUALS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '4',
          name: 'ADMINISTRATE_ACTIVITIES',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '5',
          name: 'ADMINISTRATE_RISK_ANALYSIS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '6',
          name: 'ADMINISTRATE_PROJECTS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '7',
          name: 'ADMINISTRATE_FDV',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '8',
          name: 'ADMINISTRATE_INTERNAL_CONTROL',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '9',
          name: 'ADMINISTRATE_INTERNAL_NEWS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '38',
          name: 'ADMINISTRATE_FOOD_SAFETY',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '50',
          name: 'ADMINISTRATE_ARCHIVE',
          isChecked: true,
          rightsType: 1
        },
        {
          id: '51',
          name: 'ADMINISTRATE_KUBA_CONTROL',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '46',
          name: 'ADMINISTRATE_PRIVATE_DOCUMENTS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '19',
          name: 'DEVIATIONS_OWN_DEPARTMENT',
          isChecked: false,
          rightsType: 3
        },
        {
          id: '48',
          name: 'ADMINISTRATE_OTHER_SYSTEMS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '49',
          name: 'ADMINISTRATE_QUALITY_SYSTEM',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '16',
          name: 'ADMINISTRATE_DEVIATION',
          isChecked: false,
          rightsType: 3
        },
        {
          id: '45',
          name: 'DOCUMENTED_TRAINING_RIGHTS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '10',
          name: 'APPROVE_ABSENCE',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '11',
          name: 'APPROVE_LEAVE',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '12',
          name: 'APPROVE_TIMETABLE',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '13',
          name: 'ADD_EMPLOYEE',
          isChecked: false,
          rightsType: 2
        },
        {
          id: '14',
          name: 'DEPARTMENT_EMPLOYEE_RIGHTS',
          isChecked: false,
          rightsType: 2
        },
        {
          id: '15',
          name: 'HIDE_EMPLOYEE_LIST',
          isChecked: false,
          rightsType: 2
        },
        {
          id: '17',
          name: 'VIEW_DEVIATION',
          isChecked: false,
          rightsType: 3
        }
      ];
    } else {
      this.userRightsData = [
        {
          id: '1',
          name: 'ACTIVE_ACCOUNT',
          isChecked: true,
          rightsType: 1
        },
        {
          id: '2',
          name: 'EDIT_MY_PAGE',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '3',
          name: 'EDIT_MANUALS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '4',
          name: 'ADMINISTRATE_ACTIVITIES',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '5',
          name: 'ADMINISTRATE_RISK_ANALYSIS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '6',
          name: 'ADMINISTRATE_PROJECTS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '7',
          name: 'ADMINISTRATE_FDV',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '8',
          name: 'ADMINISTRATE_INTERNAL_CONTROL',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '9',
          name: 'ADMINISTRATE_INTERNAL_NEWS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '38',
          name: 'ADMINISTRATE_FOOD_SAFETY',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '50',
          isChecked: false,
          name: 'ADMINISTRATE_ARCHIVE',
          rightsType: 1
        },
        {
          id: '45',
          name: 'DOCUMENTED_TRAINING_RIGHTS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '51',
          name: 'ADMINISTRATE_KUBA_CONTROL',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '48',
          name: 'ADMINISTRATE_OTHER_SYSTEMS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '49',
          name: 'ADMINISTRATE_QUALITY_SYSTEM',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '16',
          name: 'ADMINISTRATE_DEVIATION',
          isChecked: false,
          rightsType: 3
        },
        {
          id: '46',
          name: 'ADMINISTRATE_PRIVATE_DOCUMENTS',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '10',
          name: 'APPROVE_ABSENCE',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '11',
          name: 'APPROVE_LEAVE',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '12',
          name: 'APPROVE_TIMETABLE',
          isChecked: false,
          rightsType: 1
        },
        {
          id: '13',
          name: 'ADD_EMPLOYEE',
          isChecked: false,
          rightsType: 2
        },
        {
          id: '14',
          name: 'DEPARTMENT_EMPLOYEE_RIGHTS',
          isChecked: false,
          rightsType: 2
        },
        {
          id: '15',
          name: 'HIDE_EMPLOYEE_LIST',
          isChecked: false,
          rightsType: 2
        },

        {
          id: '17',
          name: 'VIEW_DEVIATION',
          isChecked: false,
          rightsType: 3
        },
        {
          id: '19',
          name: 'DEVIATIONS_OWN_DEPARTMENT',
          isChecked: false,
          rightsType: 3
        }
      ];
    }
    let ahlsellRights = [
      {
        id: '26',
        name: 'FRAMEWORK_AGREEMENT_RIGHTS',
        isChecked: false,
        rightsType: 1
      },
      {
        id: '27',
        name: 'SERVICE_AGREEMENT_RIGHTS',
        isChecked: false,
        rightsType: 1
      },
      {
        id: '28',
        name: 'EL_RIGHTS',
        isChecked: false,
        rightsType: 1
      }
    ];

    let electroUserRights = [
      {
        id: '37',
        name: 'SERVICE_LEADER_ELECTRO',
        isChecked: false,
        rightsType: 1
      },
      {
        id: '38',
        name: 'SERVICE_INSTALLER_ELECTRO',
        isChecked: false,
        rightsType: 1
      }
    ];

    let businessFeatures = BaseServices.userFeatures;
    //when admin or portal edits a user in some business
    if (
      window.name === 'Remote' ||
      BaseServices.roleId === '1' ||
      BaseServices.roleId === '2'
    ) {
      let result = this.route.snapshot.data['businessdata'];
      if (result) {
        businessFeatures = <any>JSON.parse(result.Features);
        let mainFeature = businessFeatures.filter(
          (x: any) => x.id === FeatureKey.FOLLOW_UP
        );
        let electroFeature = businessFeatures.filter(
          (x: any) => x.id === FeatureKey.ELECTRO
        );
        if (electroFeature.length) {
          this.isElectroRights = electroFeature[0].checked;
          if (this.isElectroRights && this.featureId === Module.EMPLOYEES) {
            this.userRightsData.push(...electroUserRights);
          }
        }
        let kundeFeature = businessFeatures.filter(
          (x: any) => x.id === FeatureKey.KUNDE_EL
        );
        let FDVFeature = businessFeatures.filter(
          (x: any) => x.id === FeatureKey.FDV
        );
        let ProjFeature = businessFeatures.filter(
          (x: any) => x.id === FeatureKey.PROJECT
        );

        if (kundeFeature.length > 0) {
          this.isKundeElExiats =
            kundeFeature[0].checked === true ? kundeFeature[0].checked : false;
        }
        if (FDVFeature.length > 0) {
          this.isFDVExists =
            FDVFeature[0].checked === true ? FDVFeature[0].checked : false;
        }
        if (ProjFeature.length > 0) {
          this.isProjExists =
            ProjFeature[0].checked === true ? ProjFeature[0].checked : false;
        }
      }
    } else {
      let mainFeature = businessFeatures.filter(
        (x: any) => x.id === FeatureKey.FOLLOW_UP
      );
      let electroFeature = businessFeatures.filter(
        (x: any) => x.id === FeatureKey.ELECTRO
      );
      if (electroFeature.length) {
        this.isElectroRights = electroFeature[0].checked;
        if (this.isElectroRights && this.featureId === Module.EMPLOYEES) {
          this.userRightsData.push(...electroUserRights);
        }
      }
      let kundeFeature = businessFeatures.filter(
        (x: any) => x.id === FeatureKey.KUNDE_EL
      );
      let FDVFeature = businessFeatures.filter(
        (x: any) => x.id === FeatureKey.FDV
      );
      let ProjFeature = businessFeatures.filter(
        (x: any) => x.id === FeatureKey.PROJECT
      );
      if (mainFeature.length) {
        this.isKundeElExiats = kundeFeature
          ? kundeFeature.length
            ? kundeFeature[0].checked
            : false
          : false;
        this.isFDVExists = FDVFeature
          ? FDVFeature.length
            ? FDVFeature[0].checked
            : false
          : false;
        this.isProjExists = ProjFeature
          ? ProjFeature.length
            ? ProjFeature[0].checked
            : false
          : false;
      }
    }
    if (BaseServices.ApplicationId === Application.AHLSELL) {
      this.userRightsData.push(...ahlsellRights);
    }
    let isActiveAccount = false;
    const userControl = <FormArray>(
      this.businessUserForm.controls['userCategories']
    );
    if (data && data.Rights) {
      let dataList = JSON.parse(data.Rights || null);
      if (dataList && dataList.length > 0) {
        if (dataList[0].id === '1') {
          isActiveAccount = dataList[0].isChecked;
        }
      }
    }
    for (let i = 0; i < this.userRightsData.length; i++) {
      let fg = new FormGroup({});
      fg.addControl(
        `${this.userRightsData[i].id}`,
        new FormControl({
          value: data
            ? this.arrayCompare(data.Rights, this.userRightsData[i].id)
            : this.userRightsData[i].isChecked,
          disabled: this.isLoginUser
            ? true
            : this.userRightsData[i].id === '1'
            ? false
            : !isActiveAccount
        })
      );
      userControl.push(fg);
    }
    // for guest role dropdown
    if (this.featureId === Module.CLIENT) {
      this.guestRightsData = HelperService.filterArrayAgainstArray(
        this.GuestRights,
        [0, Module.CLIENT],
        'Module'
      );
      this.hideEmployeeRights = true;
    } else if (this.featureId === Module.CLIENT_CONTACT) {
      this.guestRightsData = HelperService.filterArrayAgainstArray(
        this.GuestRights,
        [0, Module.CLIENT_CONTACT],
        'Module'
      );
      if (this.isElectroRights) {
        this.showElectroClientRights = true;
        this.electroRightsHead =
          BaseServices.ApplicationId === Application.AHLSELL
            ? 'IK_CLIENT'
            : 'ELECTRO';
        let electroGuestRights = [
          {
            id: '41',
            name: 'HIDE_DEVIATIONS',
            isChecked: false,
            rightsType: 7
          },
          {
            id: '42',
            name: 'DEVIATIONS_READONLY',
            isChecked: false,
            rightsType: 7
          },
          {
            id: '43',
            name: 'EDIT_DEVIATIONS',
            isChecked: false,
            rightsType: 7
          },
          {
            id: '44',
            name: 'ADD_DEVIATIONS',
            isChecked: false,
            rightsType: 7
          }
        ];
        this.guestRightsData.push(...electroGuestRights);
      }
      this.hideEmployeeRights = true;
    } else if (this.featureId === Module.CONTRACTOR) {
      this.guestRightsData = HelperService.filterArrayAgainstArray(
        this.GuestRights,
        [0, Module.CONTRACTOR],
        'Module'
      );
      this.hideEmployeeRights = true;
    } else if (this.featureId === Module.CONTRACTOR_CONTACT) {
      this.guestRightsData = HelperService.filterArrayAgainstArray(
        this.GuestRights,
        [0, Module.CONTRACTOR_CONTACT],
        'Module'
      );
      this.hideEmployeeRights = true;
    } else if (
      this.featureId === Module.EMPLOYEES ||
      this.featureId === Module.CONTACT
    ) {
      this.guestRightsData = HelperService.filterArrayAgainstArray(
        this.GuestRights,
        [0, Module.EMPLOYEES, Module.CONTACT],
        'Module'
      );
      if (BaseServices.ApplicationId === Application.AHLSELL) {
        if (this.isKundeElExiats) {
          this.showChooseKundeEL = false;
          let ahlsellRights = [
            {
              id: '29',
              name: 'Choose Kunde EL',
              isChecked: false,
              rightsType: 1,
              Module: [Module.EMPLOYEES, Module.CONTACT]
            }
          ];
          this.guestRightsData.push(...ahlsellRights);
        }

        if (this.isFDVExists || this.isProjExists) {
          this.showChooseProject = false;
          let ahlsellRights = [
            {
              id: '22',
              name: 'CHOOSE_PROJECT_FDV',
              isChecked: false,
              rightsType: 1,
              Module: [Module.EMPLOYEES, Module.CONTACT]
            }
          ];
          this.guestRightsData.push(...ahlsellRights);
        }
      }
      this.hideEmployeeRights = false;
    } else {
      this.guestRightsData.push(this.GuestRights);
    }
    const guestcontrol = <FormArray>(
      this.businessUserForm.controls['guestCategories']
    );
    for (let j = 0; j < this.guestRightsData.length; j++) {
      let ft = new FormGroup({});
      ft.addControl(
        `${this.guestRightsData[j].id}`,
        new FormControl({
          value: data
            ? this.arrayCompare(data.Rights, this.guestRightsData[j].id)
            : this.guestRightsData[j].isChecked,
          disabled: this.isLoginUser
            ? true
            : this.guestRightsData[j].id === '1'
            ? false
            : !isActiveAccount
        })
      );
      guestcontrol.push(ft);
    }
    // for editor role dropdown
    this.editorRightsData = [
      {
        id: '1',
        name: 'ACTIVE_ACCOUNT',
        isChecked: true,
        rightsType: 1
      },
      {
        id: '10',
        name: 'APPROVE_ABSENCE',
        isChecked: false,
        rightsType: 1
      },
      {
        id: '11',
        name: 'APPROVE_LEAVE',
        isChecked: false,
        rightsType: 1
      },
      {
        id: '12',
        name: 'APPROVE_TIMETABLE',
        isChecked: false,
        rightsType: 1
      }
    ];
    const userEditorControl = <FormArray>(
      this.businessUserForm.controls['editorCategories']
    );
    for (let k = 0; k < this.editorRightsData.length; k++) {
      let fk = new FormGroup({});
      fk.addControl(
        `${this.editorRightsData[k].id}`,
        new FormControl({
          value: data
            ? this.arrayCompare(data.Rights, this.editorRightsData[k].id)
            : this.editorRightsData[k].isChecked,
          disabled: this.isLoginUser
            ? BaseServices.roleId === '3'
              ? this.editorRightsData[k].id === '1'
              : true
            : this.editorRightsData[k].id === '1'
            ? false
            : !isActiveAccount
        })
      );
      userEditorControl.push(fk);
    }
    applyDeviationRightsExclusivity(this.businessUserForm, 'userCategories');
    applyDeviationRightsExclusivity(this.businessUserForm, 'guestCategories');
  }

  /**
   * Compares an array of objects to find a match based on a key.
   *
   * @param list - The JSON string representing the array of objects.
   * @param key - The key to match against the 'id' property of each object.
   * @returns The 'isChecked' property of the matched object, or false if no match is found.
   */
  arrayCompare(list: any, key: number) {
    let isMatched = false;
    let dataList = JSON.parse(list || null);
    if (dataList && dataList.length > 0) {
      for (let index = 0; index < dataList.length; index++) {
        let element = dataList[index];
        if (element.id.toString() === key) {
          return element.isChecked;
        }
      }
    }
    return isMatched;
  }

  /**
   * Initialize the user form
   * @param data {any}
   */
  initForm(data?: any) {
    let Id: number;
    let Name = '';
    let Email = '';
    let Username = '';
    let Password = '';
    let RoleId: number;
    let Status = '';
    let Mobile = '';
    let ownerofAccount: string;
    let allCategories: any | FormArray = new FormArray([]);
    let gCategories: any | FormArray = new FormArray([]);
    let eCategories: any | FormArray = new FormArray([]);
    let countryCode = 0;

    if (data) {
      Id = data.Id ? +data.Id : 0;
      Name = data.Name ? data.Name : '';
      Email = data.Email ? data.Email : '';
      Username = data.Username ? data.Username : '';
      Password = '';
      RoleId = data.RoleId ? +data.RoleId : 0;
      Status = data.Status ? data.Status : '1';
      countryCode = data.CountryCode ? +data.CountryCode : 2;
      Mobile = data.Mobile ? data.Mobile : '';
      ownerofAccount = data.Name ? data.Name : '';
      this.createdOn = data.CreatedOn;
      this.createdBy = data.CreatedBy;
      this.showChooseProject = data.IsProjectFeature || data.IsFDVFeature;
      // assigned projects
      if (data.UserProjects) {
        this.selectedProject = [];
        data.UserProjects.forEach((element: any) => {
          this.selectedProject.push({ Id: element.ProjectId });
        });
      }
      // assigned fdvs
      if (data.UserFireDeviations) {
        this.selectedFDV = [];
        data.UserFireDeviations.forEach((element: any) => {
          this.selectedFDV.push({ Id: element.FireDeviationId });
        });
      }
      if (data.ManagerRights != null && data.ManagerRights.length > 0) {
        this.selectedManager = [];
        this.isShowManagerUserDepartment = true;
        let arrayDept: any = [];
        data.ManagerRights.forEach((element: any) => {
          this.selectedManager.push(element.DepartmentId);
          let dept = this.departments.filter(item => item.value === element.DepartmentId
          );
          arrayDept.push(dept);
        });
        let flatDept = arrayDept.flat([1]);
      }
      // assigned contracts
      if (data.UserKundeEL) {
        this.selectedContract = [];
        data.UserKundeEL.forEach((element: any) => {
          this.selectedContract.push({ Id: element.KundeELId });
        });
      }
      if (RoleId > 0) {
        this.setRoleVisiblity(RoleId);
      }
      if (RoleId === Roles.EDITOR) {
        this.rightsData = this.editorRightsData;
      } else if (RoleId === Roles.GUEST) {
        this.rightsData = this.guestRightsData;
      } else if (RoleId === Roles.USER) {
        this.rightsData = this.userRightsData;
      }
      // copying the existing rights to new json
      if (data.Rights) {
        JSON.parse(data.Rights).forEach((r: any) => {
          if (r.name === 'CHOOSE_PROJECT_FDV' && r.isChecked === true) {
            this.showChooseProject = true;
          }
          this.rightsData.forEach((rd: any) => {
            if (r.id == rd.id) {
              rd.isChecked = r.isChecked;
            }
          });
        });
      }
    }

    this.businessUserForm = new FormGroup({
      Id: new FormControl(Id!),
      Name: new FormControl(Name),
      Email: new FormControl(Email, [ValidationService.emailValidator]),
      Username: new FormControl(
        Username,
        [Validators.required],
        this.isUserNameUnique.bind(this)
      ),
      newPasswordValidation: this.formBuilder.group(
        {
          Password: new FormControl( Password, [Validators.required]),
          ConfirmPassword: new FormControl(Password, [Validators.required])
        }
      ),
      RoleId: new FormControl(RoleId!),
      Status: new FormControl(Status),
      countryCode: new FormControl(countryCode),
      Mobile: new FormControl(Mobile),
      ownerofAccount: new FormControl(ownerofAccount!),
      userCategories: allCategories,
      guestCategories: gCategories,
      editorCategories: eCategories,
      OldPassword: new FormControl(),
      selectedManager: new FormControl(this.selectedManager),
      selectedObserver: new FormControl(this.selectedObserver)
    });
    this.bindRightsCheckbox(data);
  }

  /**
   * Hide & Show the Rights Based upon the Role
   * @param val{number} RoleId
   */
  setRoleVisiblity(val: number) {
    if (val === Roles.EDITOR) {
      this.editedGuest = false;
      this.editedUser = false;
      this.editedEditor = true;
      this.rightsData = this.editorRightsData;
    }
    if (val === Roles.GUEST) {
      this.editedEditor = false;
      this.editedUser = false;
      this.editedGuest = true;
      this.rightsData = this.guestRightsData;
    }
    if (val === Roles.USER) {
      this.editedEditor = false;
      this.editedGuest = false;
      this.editedUser = true;
      this.rightsData = this.userRightsData;
    }
  }

  /**
   * check if the username is unique
   */
  isUserNameUnique(control: FormControl) {
    const q = new Promise(resolve => {
      setTimeout(() => {
        if (control.value === this.cachedUserName) {
          this.usernameWarning = null;
          resolve(null);
        } else {
          this.subscriptions.push(
            this.employeeServices.getUserNameStatus(control.value).subscribe(
              (status: string) => {
                this.usernameWarning = null;
                this.loading = false;
                if (status === 'Active') {
                  this.usernameWarning = 'active';
                  resolve({ invalidUserNameWithId: true, usernameStatus: 'active' });
                } else if (status === 'Deleted') {
                  this.usernameWarning = 'deleted';
                  resolve(null);
                } else if (status === 'Inactive') {
                  this.usernameWarning = 'inactive';
                  resolve(null);
                } else {
                  resolve(null);
                }
              },
              () => {
                resolve({ invalidUserNameWithId: true, usernameStatus: 'active' });
              }
            )
          );
        }
      }, 1000);
    });
    return q;
  }

  /**
   * Check if the password matches the confirm password
   */
  isPasswordMatch() {
    const q = new Promise(resolve => {
      setTimeout(() => {
        {
          resolve({ invalidPassWord: true });
        }
      }, 1000);
    });
    return q;
  }

  /**
   * Method to go back to the user list
   */
  gotoList() {
    this._location.back();
  }

  /**
   * Method to clear the username field within the user form
   */
  clearUserName() {
    this.businessUserForm.get('Username')!.patchValue('');
  }

  /**
   * Method to reset the users password
   * @param IsSendSMS Check if the user wants to send an SMS with the new password
   */
  resetPassWord(IsSendSMS: boolean) {
    this.userCredentials.Id = this.Id;
    this.languageId = parseInt(sessionStorage.getItem('languageId')!);
    this.userCredentials.Password =
      this.updatePasswordForm.value.passwordValidation.Password;
    this.userCredentials.Password =
      this.updatePasswordForm.value.passwordValidation.ConfirmPassword;
    this.validationErrors = [];
    if (IsSendSMS === false) {
      this.subscriptions.push(
        this.businessServices
          .updatePassword(this.userCredentials)
          .subscribe
            (result => {
              if (result === false) {
                this.isPasswordMatch();
              } else {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.clear();
              }
            },
            (error: any) => {
              if (error.status === 422) {
                this.validationErrors = error.error?.FailedChecks || [];
              }
            }
          )
      );
    } else {
      this.subscriptions.push(
        this.businessServices
          .updatePasswordAndSendSMS(this.userCredentials, this.languageId)
          .subscribe(result => {
              if (result === false) {
                this.isPasswordMatch();
              } else {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.clear();
              }
            },
            (error: any) => {
              if (error.status === 422) {
                this.validationErrors = error.error?.FailedChecks || [];
              }
            }
          )
      );
    }
  }
  clear() {
    this.showPasswordResetDialog = false;
    this.validationErrors = [];
    this.updatePasswordForm.reset();
  }
  showResetPassword() {
    this.showPasswordResetDialog = true;
  }

  get GuestRights() {
    return (this.guestRightsData = [
      {
        id: '1',
        name: 'ACTIVE_ACCOUNT',
        isChecked: true,
        rightsType: 1,
        Module: [0]
      },
      {
        id: '15',
        name: 'HIDE_EMPLOYEE_LIST',
        isChecked: false,
        rightsType: 2,
        Module: [Module.EMPLOYEES, Module.CONTACT]
      },
      {
        id: '20',
        name: 'DEVIATION_RIGHTS',
        isChecked: false,
        rightsType: 3,
        Module: [
          Module.EMPLOYEES,
          Module.CONTACT,
          Module.CLIENT,
          Module.CLIENT_CONTACT,
          Module.CONTRACTOR,
          Module.CONTRACTOR_CONTACT
        ]
      },
      {
        id: '17',
        name: 'VIEW_DEVIATION',
        isChecked: false,
        rightsType: 3,
        Module: [Module.EMPLOYEES, Module.CONTACT]
      },
      {
        id: '18',
        name: 'DISPLAY_OWN_DEVIATIONS',
        isChecked: false,
        rightsType: 3,
        Module: [Module.EMPLOYEES, Module.CONTACT]
      },
      {
        id: '19',
        name: 'DEVIATIONS_OWN_DEPARTMENT',
        isChecked: false,
        rightsType: 3,
        Module: [Module.EMPLOYEES, Module.CONTACT]
      },
      {
        id: '21',
        name: 'VIEW_MANUALS',
        isChecked: false,
        rightsType: 1,
        Module: [Module.EMPLOYEES, Module.CONTACT]
      },
      {
        id: '24',
        name: 'CHECKLIST_RIGHTS',
        isChecked: false,
        rightsType: 1,
        Module: [
          Module.CLIENT,
          Module.CLIENT_CONTACT,
          Module.CONTRACTOR,
          Module.CONTRACTOR_CONTACT
        ]
      },
      {
        id: '25',
        name: 'READING_SJA_RIGHTS',
        isChecked: false,
        rightsType: 1,
        Module: [Module.CONTRACTOR, Module.CONTRACTOR_CONTACT]
      }
    ]);
  }

  chooseProject() {
    this.showProjectDialog = true;
  }
  chooseKundeEL() {
    this.showKundeELDialog = true;
  }
  /**
   * save project and fdv
   */
  saveProjectAndFdv() {
    let projectUserListDto: any = [];
    let fdvUserListDto: any = [];
    this.showLoader = true;
    // assign project to guest user
    if (this.selectedProject.length > 0) {
      this.selectedProject.forEach((element: any) => {
        let projectUserDto = new ProjectUserDto();
        projectUserDto.UserId = this.Id;
        projectUserDto.ProjectId = element.Id;
        projectUserListDto.push(projectUserDto);
      });
    }
    // assign fdv to guest user
    if (this.selectedFDV.length > 0) {
      this.selectedFDV.forEach((element: any) => {
        let fdvUserDto = new FireDeviationUserDto();
        fdvUserDto.UserId = this.Id;
        fdvUserDto.FireDeviationId = element.Id;
        fdvUserListDto.push(fdvUserDto);
      });
    }

    this.subscriptions.push(
      this.businessServices
        .saveProjectFDVforGuest(fdvUserListDto, projectUserListDto, +this.Id)
        .subscribe(responseList => {
          if (responseList !== null) {
            this.showProjectDialog = false;
            this.showLoader = false;
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
          }
        })
    );
  }
  /**
   * save Ik kunde EL
   */
  saveKundeEL() {
    let kundeELDto: any = [];
    if (this.selectedContract.length > 0) {
      this.selectedContract.forEach((element: any) => {
        let elUserDto = new KundeELUser();
        elUserDto.UserId = this.Id;
        elUserDto.KundeELId = element.Id;
        kundeELDto.push(elUserDto);
      });
      this.subscriptions.push(
        this.businessServices
          .assignKundeELUsers(kundeELDto)
          .subscribe(res => {})
      );
    }
  }

  /**
   * Checks if the current user is the same as the user being edited.
   * Sets `isLoginUser` to `true` if they are the same, otherwise sets it to `false`.
   */
  onRightsDisableOwnUser() {
    this.isLoginUser = BaseServices.UserId === this.Id ? true : false;
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
